import { useTranslation } from 'react-i18next'
import cloudNotAvailable from 'core/assets/images/icons/cloud_not_available.svg'

type WidgetErrorCardProps = {
  titleKey: string
  messageKey?: string
  testId?: string
}

const WidgetErrorCard = ({ titleKey, messageKey = 'general.homepage.unavailable', testId }: WidgetErrorCardProps) => {
  const { t } = useTranslation()

  return (
    <div data-testid={testId} data-test-id={testId} className="mg-widget-error-card">
      <div className="mg-widget-error-card-header">
        <img src={cloudNotAvailable} alt="" className="mg-widget-error-card-icon" />
        <p className="mg-widget-error-card-label vp-body-s">{t(titleKey)}</p>
      </div>
      <p className="mg-widget-error-card-message vp-body-s">{t(messageKey)}</p>
    </div>
  )
}

export default WidgetErrorCard
